// extracted by mini-css-extract-plugin
module.exports = {"footerMenu":"styles-module--footerMenu--1sYjR","link":"styles-module--link--2QteD","active":"styles-module--active--hMc7t"};